import React, { useState, useEffect, useRef } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postCustomersURL } from "../utils/api";
import { useReactToPrint } from 'react-to-print';
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Icon,
    Image,
    Table,
    Thead,
    Tfoot,
    Tbody,
    Th,
    Tr,
    Td,
    VStack,
} from "@chakra-ui/react";
import { FaTimesCircle, FaMinusCircle, FaPlusSquare } from "react-icons/fa";
import EasyChekLogo from "assets/images/easychek_logo.jpg";
import "assets/css/print.css";

function ViewOrder({
    isOpen,
    onClose,
    orderData,
}) {


    if (orderData == null) {
        return (<></>);
    }

    const [ laborTotal, setLaborTotal ] = useState(0);
    const [ partsTotal, setPartsTotal ] = useState(0);
    // const [ bodyLineCount, setBodyLineCount ] = useState(0);
    const [ emptyLines, setEmptyLines ] = useState(0);

    useEffect(() => {
        if (orderData && isOpen) {

            // console.log(orderData);
            let lTotal = 0;
            let pTotal = 0;
            let bLineCount = 0;
            if (orderData.services.length > 0) {
                orderData.services.forEach((os, osIndex) => {
                    // console.log(parseFloat(os.price));
                    lTotal += parseFloat(os.price);
                    // console.log(laborTotal);
                    if (os.products.length > 0) {
                        os.products.forEach((p) => {
                            pTotal += (parseFloat(p.quantity) * parseFloat(p.price));
                            bLineCount++;
                        });
                        // console.log(partsTotal);
                    }
                    bLineCount++;
                });
            }
            setLaborTotal(lTotal);
            setPartsTotal(pTotal);
            // setBodyLineCount(bLineCount);
            if (bLineCount < 6) {
                setEmptyLines(6);
            }
        }

    }, [orderData, isOpen]);

    // console.log(partsTotal, laborTotal);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const createEmptyLine = (postKey) => {
        return <Tr key={`osrow-empty-${postKey}`}>
            <Td fontSize="xs"
                textAlign="start"
                colSpan={8}
                borderRight={"1px solid gray"}
                borderTop={"1px solid gray"}
                paddingTop={0}
                paddingBottom={0}
            >&nbsp;</Td>
            <Td fontSize="xs"
                textAlign="start"
                colSpan={2}
                borderRight={"1px solid gray"}
                borderTop={"1px solid gray"}
                paddingTop={0}
                paddingBottom={0}
            ></Td>
            <Td fontSize="xs"
                textAlign="start"
                colSpan={2}
                borderRight={"1px solid gray"}
                borderTop={"1px solid gray"}
                paddingTop={0}
                paddingBottom={0}
            >
                <Button 
                    className="hidden-on-print"
                    p="0px" bg="transparent" 
                    title="Remove empty line"
                    iconSpacing="0rem"
                    height="24px"
                    onClick={removeEmptyLine}
                    >
                    <Flex color="red" cursor="pointer" align="center" p="12px">
                        <Icon as={FaMinusCircle} me="2px" />
                    </Flex>
                </Button>
            </Td>
        </Tr>;
    }

    function addEmptyLine() {
        setEmptyLines((emptyLines + 1));
    }

    function removeEmptyLine() {
        setEmptyLines((emptyLines - 1));
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered >
            <ModalOverlay />
            <ModalHeader>
            </ModalHeader>
            <ModalContent>
                <ModalCloseButton />
                <ModalBody width={"100%"}  p={"32px"}>
                    <Flex direction={"row"}>
                        <Spacer />
                        <Box width={"50%"} 
                            // direction="column"
                            alignSelf="center"
                            justifySelf="center"
                        >
                            <VStack >
                                <Flex ref={componentRef}
                                    direction="column"
                                    alignSelf="center"
                                    justifySelf="center"
                                    justifyContent="center"
                                    width={"100%"} 
                                    m="4px"
                                    mt="10px"
                                >


                                    <style type="text/css" media="print">{"\
                                        @page {\ size: A4;\ }\
                                    "}</style>

                                    {/** Logo and Header */}
                                    <Flex 
                                        direction="row"
                                        textAlign="center"
                                        justifyContent="center"
                                        align="center"
                                        mt="4px"
                                        mb="12px"
                                    >
                                        <Image
                                            // boxSize="100px"
                                            width={"120px"}
                                            objectFit="fit"
                                            src={EasyChekLogo}
                                            alt="Easy Chek 7 Logo"
                                        />
                                        <Flex direction={"column"}>
                                            <Text 
                                                fontSize="22px"
                                                color={"black"}
                                                fontWeight="bold"
                                                textAlign="center"
                                            >
                                                EASY CHEK 7 AUTO SERVICE CORP.
                                            </Text>
                                            <Text
                                                fontSize="xs"
                                                textAlign="center"
                                            >
                                                14-5 FIL AM ROAD CUTCUT ANGELES CITY PAMPANGA
                                            </Text>
                                            <Text
                                                fontSize="xs"
                                                textAlign="center"
                                            >
                                                CONTACT NO. 0917631-8628(GLOBE) AND 0943-706-0855(SMART)
                                            </Text>
                                        </Flex>
                                    </Flex>

                                    {/** TABLE */}
                                    <Table width={"99%"} border={"1px solid gray"} variant="unstyled">
                                        <Thead>
                                            <Tr p={0}>
                                                <Th colSpan={12}
                                                    borderBottom={"1px solid gray"}>
                                                    <Text 
                                                        fontSize="20px"
                                                        color={"black"}
                                                        fontWeight="bold"
                                                        textAlign="center"
                                                    >
                                                        JOB ORDER
                                                    </Text>
                                                </Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            <Tr>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    paddingInlineStart={2} 
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    colSpan={9}
                                                >NAME: { orderData.customer.companyName 
                                                    ? orderData.customer.companyName 
                                                    : `${orderData.customer.firstName} ${orderData.customer.lastName} `
                                                } </Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    borderLeft={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    colSpan={3}
                                                >DATE: { new Date(orderData.createdAt).toLocaleDateString() }</Td>
                                            </Tr>
                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    paddingInlineStart={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    colSpan={9}
                                                >CONTACT NO: {orderData.customer.mobile ?? ""}</Td>
                                                <Td colSpan={3}
                                                    fontSize="xs"
                                                    textAlign="center"
                                                    borderLeft={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >WORKING DAYS</Td>
                                            </Tr>
                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    paddingInlineStart={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >ADDRESS:</Td>
                                                <Td colSpan={8}></Td>
                                                <Td colSpan={3}
                                                    fontSize="xs"
                                                    textAlign="center"
                                                    borderLeft={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >{ orderData.workingDays ?? ""}</Td>
                                            </Tr>
                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={3}
                                                    borderRight={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >MAKE: {orderData.carMake ?? ''}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={3}
                                                    borderRight={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >TYPE: {orderData.carType ?? ''}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >YEAR: {orderData.carYear ?? ''}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >PLATE NO: {orderData.carPlate ?? ''}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >ODOMETER:  {orderData.carOdometer ?? ''}</Td>
                                            </Tr>

                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={1}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={2}
                                                    paddingBottom={1}
                                                    width="8%"
                                                >QTY</Td>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={7}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={2}
                                                    paddingBottom={1}
                                                >NATURE OF WORK</Td>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={2}
                                                    paddingBottom={1}
                                                >PARTS</Td>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={2}
                                                    paddingBottom={1}
                                                >LABOR</Td>
                                            </Tr>

                                            { orderData.services.map((os, osIndex) => {
                                                    return os.products.map((p, pIndex) => {
                                                        if (parseInt(p.quantity) === 0) {
                                                            return null;
                                                        }
                                                        return <Tr key={`osrow-${osIndex}-${pIndex}`}>
                                                            <Td fontSize="xs"
                                                                textAlign="center"
                                                                colSpan={1}
                                                                borderRight={"1px solid gray"}
                                                                paddingTop={0}
                                                                paddingBottom={0}
                                                            >{p.quantity}</Td>
                                                            <Td fontSize="xs"
                                                                textAlign="start"
                                                                colSpan={7}
                                                                borderRight={"1px solid gray"}
                                                                paddingTop={0}
                                                                paddingBottom={0}
                                                            >{p.name} {p.description ? `(${p.description})` : ''}</Td>
                                                            <Td fontSize="xs"
                                                                textAlign="center"
                                                                colSpan={2}
                                                                borderRight={"1px solid gray"}
                                                                paddingTop={0}
                                                                paddingBottom={0}
                                                            >₱{Number((parseFloat(p.price) * parseFloat(p.quantity))).toLocaleString()}</Td>
                                                            <Td fontSize="xs"
                                                                textAlign="center"
                                                                colSpan={2}
                                                                borderRight={"1px solid gray"}
                                                                paddingTop={0}
                                                                paddingBottom={0}
                                                            ></Td>
                                                        </Tr>
                                                    })
                                                    
                                                })

                                            }

                                            { orderData.services.map((os, osIndex) => {
                                                    if (os.title.toString().trim().toLowerCase() == 'non-service' 
                                                        && parseInt(os.price) === 0) {
                                                        return null;
                                                    }
                                                    return <Tr key={`osrow-${osIndex}`}>
                                                        <Td fontSize="xs"
                                                            textAlign="start"
                                                            colSpan={1}
                                                            borderRight={"1px solid gray"}
                                                            borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                            paddingTop={0}
                                                            paddingBottom={0}
                                                        ></Td>
                                                        <Td fontSize="xs"
                                                            textAlign="start"
                                                            colSpan={7}
                                                            borderRight={"1px solid gray"}
                                                            borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                            paddingTop={0}
                                                            paddingBottom={0}
                                                        >{ os.title }</Td>
                                                        <Td fontSize="xs"
                                                            textAlign="start"
                                                            colSpan={2}
                                                            borderRight={"1px solid gray"}
                                                            borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                            paddingTop={0}
                                                            paddingBottom={0}
                                                        ></Td>
                                                        <Td fontSize="xs"
                                                            textAlign="start"
                                                            colSpan={2}
                                                            borderRight={"1px solid gray"}
                                                            borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                            paddingTop={0}
                                                            paddingBottom={0}
                                                        >₱{Number(os.price).toLocaleString()}</Td>
                                                    </Tr>
                                                })

                                            }

                                            { orderData.mechanics.map((os, osIndex) => {
                                                    if (os.fullName.toString().trim().toLowerCase() == 'non mechanic') {
                                                        return null;
                                                    }
                                                    return <Tr key={`osrow-${osIndex}`}>
                                                        <Td fontSize="xs"
                                                            textAlign="start"
                                                            colSpan={8}
                                                            borderRight={"1px solid gray"}
                                                            borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                            paddingTop={0}
                                                            paddingBottom={0}
                                                        >{ os.fullName }</Td>
                                                        <Td fontSize="xs"
                                                            textAlign="start"
                                                            colSpan={2}
                                                            borderRight={"1px solid gray"}
                                                            borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                            paddingTop={0}
                                                            paddingBottom={0}
                                                        ></Td>
                                                        <Td fontSize="xs"
                                                            textAlign="start"
                                                            colSpan={2}
                                                            borderRight={"1px solid gray"}
                                                            borderTop={osIndex == 0 ? "1px solid gray" : ""}
                                                            paddingTop={0}
                                                            paddingBottom={0}
                                                        ></Td>
                                                    </Tr>
                                                })

                                            }

                                            {new Array(emptyLines).fill(0).map((x, i) => createEmptyLine(i))}

                                            <Tr key={`osrow-empty-non-val`}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={8}
                                                    borderRight={"1px solid gray"}
                                                    borderTop={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >&nbsp;</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    borderTop={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                ></Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    borderTop={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >
                                                    <Button 
                                                        className="hidden-on-print"
                                                        p="0px" bg="transparent" 
                                                        title="Add empty line"
                                                        iconSpacing="0rem"
                                                        height="24px"
                                                        onClick={() => addEmptyLine()}
                                                        zIndex={9999}
                                                        >
                                                        <Flex color="green" cursor="pointer" align="center" p="12px">
                                                            <Icon as={FaPlusSquare} me="2px" />
                                                        </Flex>
                                                    </Button>
                                                </Td>
                                            </Tr>

                                            

                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    paddingInlineStart={2}
                                                >CUSTOMER SIGNATURE</Td>
                                                <Td
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                ></Td>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >PARTIAL TOTAL</Td>
                                                <Td
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    textAlign={"center"}
                                                >
                                                    <Text>₱{Number(partsTotal).toLocaleString()}</Text>
                                                </Td>
                                                <Td 
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    textAlign={"center"}
                                                >
                                                    <Text>₱{Number(laborTotal).toLocaleString()}</Text>
                                                </Td>
                                            </Tr>

                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    paddingInlineStart={2}
                                                ></Td>
                                                <Td
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                ></Td>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >SUBTOTAL</Td>
                                                <Td
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    textAlign="center"
                                                >
                                                    <Text>₱{Number(orderData.subTotal).toLocaleString()}</Text>
                                                </Td>
                                            </Tr>

                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    paddingInlineStart={2}
                                                ></Td>
                                                <Td
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                ></Td>
                                                <Td fontSize="xs"
                                                    textAlign="center"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >DISCOUNT</Td>
                                                <Td
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    textAlign="center"
                                                >
                                                    <Text>₱{Number(orderData.discount).toLocaleString()}</Text>
                                                </Td>
                                            </Tr>


                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    paddingInlineStart={2}
                                                >ESTIMATED BY</Td>
                                                <Td
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                ></Td>
                                                <Td fontSize="xs"
                                                    fontWeight="bold"
                                                    textAlign="center"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >GRAND TOTAL</Td>
                                                <Td
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    textAlign="center"
                                                >
                                                    <Text fontWeight={"bold"}>₱{Number(orderData.total).toLocaleString()}</Text>
                                                </Td>
                                            </Tr>

                                        </Tbody>
                                        {/* <Tfoot>
                                            <Tr>
                                            <Th>To convert</Th>
                                            <Th>into</Th>
                                            <Th isNumeric>multiply by</Th>
                                            </Tr>
                                        </Tfoot> */}
                                    </Table>
                                </Flex>
                                <Button 
                                    colorScheme="teal" 
                                    variant="solid"
                                    onClick={() => handlePrint()}
                                >
                                    <Text
                                        fontSize="sm"
                                        fontWeight="600"
                                        color="teal.300"
                                        alignSelf="center"
                                    >
                                        PRINT THIS
                                    </Text>
                                </Button>
                            </VStack>
                        </Box>
                        <Spacer />
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default ViewOrder;
